import { FormattedMessage } from 'react-intl';
import { Card, Grid, List, ListItem, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { CustomListItem } from 'components/common';

export const AffordabilityResultsHeader = () => (
  <Card sx={{ minWidth: 275 }} className={'mb-4'}>
    <Grid container columnSpacing={2.75}>
      <Grid item xs={12} md={3} lg={3}>
        <List className={'w-full'}>
          <ListItem>
            <CustomListItem>
              <FormattedMessage id={'affordability.passes'} />
              <CheckIcon color='success' fontSize='large' />
            </CustomListItem>
          </ListItem>
        </List>
      </Grid>
      <Grid item xs={12} md={3} lg={3}>
        <List className={'w-full'}>
          <ListItem>
            <CustomListItem>
              <FormattedMessage id={'affordability.ftiMulitple'} />
              <Typography variant='h5' component={'span'}>
                6.5
              </Typography>
            </CustomListItem>
          </ListItem>
        </List>
      </Grid>
      <Grid item xs={12} md={6} lg={6}>
        <List className={'w-full'}>
          <ListItem>
            <CustomListItem>
              <FormattedMessage id={'affordability.declaredExpenditureOrOns'} />
              <Typography variant='h5' component={'span'}>
                <FormattedMessage id={'ons'} />
              </Typography>
            </CustomListItem>
          </ListItem>
        </List>
      </Grid>
    </Grid>
  </Card>
);
